import { MessageBar, Stack, PrimaryButton, Dialog, DialogType, DialogFooter, DefaultButton } from "@fluentui/react";
import { observer, inject } from "mobx-react";
import { Component } from "react";
import PwProps from "../props/PwProps";
import PwSheetHeader from "./PwSheetHeader";
import PwToast from "./PwToast";
import PwLoading from "./PwLoading";
import { action, reaction } from "mobx";
import { Parameter, ParameterPayload } from '../types';
import DateField from "./fields/DateField";
import StringField from "./fields/StringField";

interface PwReportState {
  parameters: Parameter[],
  isLoadingParameters: boolean
}


@inject('uiStore', 'importStore')
@observer
export default class PwReport extends Component<PwProps, PwReportState> {
  constructor(props: PwProps) {
    super(props)

    this.state = {
      parameters: [],
      isLoadingParameters: false
    }
  }

  async componentDidMount() {
    reaction(() => this.props.uiStore?.reportSelected, async () => {
      await this.getParameters();
    })
    await this.getParameters();
  }

  async getParameters() {
    await this.props.importStore?.getParameters();

    if ((this.props.importStore?.parameters || []).length === 0 && !(this.props.uiStore?.reportSelected || {}).key) {
      this.props.uiStore?.activateForceReplaceSheet();
      this.props.uiStore?.changeSection('import');
    }
  }

  async getData() {
    const parameters: ParameterPayload[] = this.props.importStore?.parameters.map((x) => ({ Name: x.Name, Value: x.Value, Type: x.Type })) ?? [];
    this.props.importStore?.getData(parameters);
  }

  async validateTable() {
    const someIsRequiredAndNotValue = this.props.importStore?.parameters.some(x => x.Required && !x.Value);
    if(someIsRequiredAndNotValue) {
      this.props.importStore?.parameters.forEach((x) => {
        if(x.Required && !x.Value) {
          x.errorMessage = `el campo ${x.Title} es requerido`
        }
      })
      return;
    } else {
      this.props.importStore?.parameters.forEach((x) => {
        x.errorMessage = "";
      })
    }
    const parameters: ParameterPayload[] = this.props.importStore?.parameters.map((x) => ({ Name: x.Name, Value: x.Value, Type: x.Type })) ?? [];
    this.props.importStore?.validateTable(parameters);
  }

  render() {
    const dialogContentNoContent = {
      type: DialogType.normal,
      title: "No se encontraron registros",
      subText: "No se encontraron registros de acuerdo a los parámetros seleccionados"
    }
    const dialogContentProps = {
      type: DialogType.normal,
      title: this.props.uiStore?.modalText.Title,
      subText: this.props.uiStore?.modalText.Description,
    };
    return <div>
      <PwSheetHeader />
      <Stack style={{ marginBottom: '24px'}}>
        <Stack.Item>
          <MessageBar dismissButtonAriaLabel="Close">
          Seleccione los parámetros correspondientes al reporte que desee generar.
          </MessageBar>
        </Stack.Item>
      </Stack>

        {this.props.importStore?.parameters.map((param: Parameter) => {
          return (
            <Stack style={{ marginBottom: "16px" }} key={param.ID}>
              {param.Type === "Date" && (
                <DateField
                  label={param.Title}
                  required={param.Required}
                  value={param.Value instanceof Date ? param.Value : undefined}
                  onChange={action((date) => { param.Value = date ?? null; })}
                  errorMessage={param.errorMessage}
                  description={param.Description}
                />
              )}
              {param.Type === "String" && (
                <StringField
                  label={param.Title}
                  required={param.Required}
                  value={typeof param.Value === "string" ? param.Value : ""}
                  onChange={action((val) => { param.Value = val; })}
                  errorMessage={param.errorMessage}
                  description={param.Description}
                />
              )}
            </Stack>
          );
        })}
        <Stack style={{ marginTop: '20px' }}>
          <Stack.Item style={{ textAlign: 'center' }}>
            <PrimaryButton
              onClick={() => this.validateTable()}
              ariaLabel={this.props.uiStore?.existingReport ? "Actualizar reporte" : "Generar reporte"}
            >
              { this.props.uiStore?.existingReport ? 'Actualizar reporte' : 'Generar reporte'}
            </PrimaryButton>
          </Stack.Item>
        </Stack>

      { this.props.importStore?.getInParameters && <PwLoading /> }

      { this.props.importStore?.importState !== 'idle' && <PwToast /> }

      <Dialog dialogContentProps={dialogContentProps} hidden={!this.props.importStore?.showDialogConfirm}>
        <DialogFooter >
          <PrimaryButton text="Continuar" onClick={() => this.getData()} />
          <DefaultButton text="Cancelar"  onClick={() => this.props.importStore?.dismissDialogConfirm()}/>
        </DialogFooter>
      </Dialog>

      <Dialog dialogContentProps={dialogContentNoContent} hidden={!this.props.uiStore?.showEmptyDialog}>
        <PrimaryButton text="Continuar" onClick={() => this.props.uiStore?.dismissDialogEmpty()}/>
      </Dialog>
    </div>
  }
}
